import React, { useState } from 'react'
import { List, Datagrid, TextField, ShowButton, EditButton, Filter, TextInput, ReferenceInput, SelectInput } from 'react-admin'
import ConfirmDeleteButton from '../../components/ConfirmDeleteButton'
import ListPagination from '../../components/ListPagination'
import ConfirmBulkActions from '../../components/ConfirmBulkActions'
import { perPage } from '../../defaults/Defaults'

const DTListFilter = (props) => {
    return (
        <Filter {...props}>
            <TextInput label="Search by name" source="displayName" alwaysOn/>
            <ReferenceInput perPage={1000000000000} label="Choose Organization" source="org_id" reference="organizations">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </Filter>
    );
}

const DispatchTabletList = (props) => {

    let [gridKey, changeGridKey] = useState(Math.random())

    const updateDataGrid = () => changeGridKey(Math.random())
    const alertM = `Warning, this cannot be undone. Any tablets currently logged into this account will be logged off.`

    return (
        <List key={gridKey} {...props} bulkActionButtons={<ConfirmBulkActions />} title="Dispatch Consoles" perPage={perPage} pagination={<ListPagination />} filters={<DTListFilter />}>
            <Datagrid>
                {/* <TextField source="email" /> */}
                <TextField label={'Name'} source="displayName" />
                <TextField label="UID" source="uid" />
                <ShowButton />
                <EditButton />
                <ConfirmDeleteButton
                    dataprovidersource={`dispatch-tablets`}
                    alertmessage={alertM}
                    update={updateDataGrid} />
            </Datagrid>
        </List>
    );
}

export default DispatchTabletList;